'use client';

import Image from 'next/image';
import { Play } from 'lucide-react';
import { cn } from '@/lib/utils';

interface MediaPlaceholderProps {
  poster: string;
  label: string;
  comingSoon: string;
  videoSrc?: string;
  className?: string;
}

export function MediaPlaceholder({
  poster,
  label,
  comingSoon,
  videoSrc,
  className,
}: MediaPlaceholderProps) {
  if (videoSrc) {
    return (
      <div className={cn('relative aspect-video w-full overflow-hidden rounded-xl border border-accent/25 bg-black shadow-md', className)}>
        <video
          src={videoSrc}
          controls
          playsInline
          className="h-full w-full object-contain"
          aria-label={label}
        />
      </div>
    );
  }

  return (
    <div
      className={cn(
        'relative aspect-video w-full overflow-hidden rounded-xl border border-accent/25 bg-navy/5 shadow-md group',
        className
      )}
      aria-label={label}
    >
      <Image
        src={poster}
        alt=""
        fill
        className="object-cover object-top opacity-40 blur-[1px] scale-105"
        sizes="(max-width: 768px) 100vw, 50vw"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-navy/80 via-navy/40 to-navy/20" />
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 p-6 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white/95 text-accent shadow-lg transition-transform group-hover:scale-105">
          <Play className="h-7 w-7 ml-1 fill-accent" aria-hidden />
        </div>
        <p className="text-sm font-medium text-white/90">{comingSoon}</p>
        <p className="text-xs text-white/70 max-w-xs">{label}</p>
      </div>
    </div>
  );
}
